import React from 'react';
import moment from 'moment/moment';
import { VendorOpportunity } from '@trnsact/trnsact-shared-types';
import { Box, Divider, ListItem, Stack, Typography } from '@mui/material';
import { DateFormats } from '../../../../constants/common';

interface Props {
  vo: VendorOpportunity;
}

export const SourceRow = ({ vo }: Props) => {
  return (
    <>
      <Divider />

      <ListItem disableGutters>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', width: '100%' }}>
          <Typography sx={{ color: '#666666', fontWeight: 500 }}>Source</Typography>

          <Stack>
            <Typography>Start Deal by: </Typography>

            <Typography>
              {vo.salesRepresentative?.fullName} {moment(vo.createdOn).format(DateFormats.DateTimeShort24Hour)}
            </Typography>
          </Stack>
        </Box>
      </ListItem>
    </>
  );
};
